export default {
    camStudy: {},
    camStudyUserList: [],
    camStudyUserBanList: [],
    studyDataList: [],
    stopWatchList: [],
    screenBlockList: {},
    isPremiumUser: false,
    banReasonList: [
        {
            reason: 'rules',
            description: '스터디 내 운영 규칙에 위배되는 활동'
        },
        {
            reason: 'advertisement',
            description: '부적절한 홍보 게시글'
        },
        {
            reason: 'sexual',
            description: '음란성 또는 청소년에게 부적합한 내용'
        },
        {
            reason: 'etc',
            description: '기타 (직접 입력)'
        },
    ],
    whileNoisePlayList: [],
    personalSetting: {},
    hashTagList: [],
    currentWhiteNoise: {},
    roomImageUrl: '',
    myStudyInfoSetting: {
        todayStudyTime: true,
        targetStudyTime: true,
        totalStudyTime: true,
        remainDays: false,
        studyDays: false,
    },
    roomImagePath: '',
    dDayList: [],
    stopWatchSetting:{},
    userTrialList: [],
    userPremiumLevel: {}
};
